<template>
  <layout-main-inner title="售后管理">
    <layout-card-wrap hasHeaderSlot>
      <el-form
        slot="form"
        :inline="true"
        class="margin-botton-0">
        <el-form-item style="margin-bottom: 0">
          <el-radio-group
            v-model="config.type"
            @change="fetchList">
            <el-radio-button :label="null">全部</el-radio-button>
            <el-radio-button :label="1">退款</el-radio-button>
            <el-radio-button :label="2">退货</el-radio-button>
            <el-radio-button :label="3">换货</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-input
            v-model.trim="config.refundNumber"
            placeholder="请输入售后编号"
            clearable></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-button
            type="primary"
            @click="handleCurrentChange(1)">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <el-table-column
          :resizable="false"
          label="售后编号"
          prop="refundNumber">
          <template slot-scope="{row}">
            <link-route :link-to="`/wxapp-order-detail?orderId=${row.orderId}&vendorId=${row.vendorId}&orderNumber=${row.orderNumber}&activeName=4`">
              {{ row.refundNumber }}
            </link-route>
          </template>
        </el-table-column>

        <el-table-column
          label="订单号"
          :resizable="false"
          prop="orderNumber">
        </el-table-column>
        <el-table-column
          label="售后类型"
          :resizable="false">
          <template slot-scope="{row}">
            {{ row.type | typeFormat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="售后状态"
          :resizable="false">
          <template slot-scope="{row}">
            <el-tag type="danger">{{ row.statusName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="申请时间"
          width="140"
          :resizable="false">
          <template slot-scope="{row}">
            <span>{{ row.createdTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :resizable="false"
          width="110">
          <template slot-scope="{row}">
            <!-- 退款 -->
            <template v-if="row.type === 1">
              <template v-if="row.status === 1 || row.status === 5">
                <el-dropdown>
                  <el-button type="warning">
                    {{ row.type | typeFormat }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <template v-if="row.status === 1">
                      <el-dropdown-item
                        @click.native="deal(row)">同意</el-dropdown-item>
                      <el-dropdown-item
                        @click.native="agreeorderreturn(row, 0)">拒绝</el-dropdown-item>
                    </template>
                    <template v-if="row.status === 5">
                      <el-dropdown-item
                        @click.native="deleteRow(row)">关闭</el-dropdown-item>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </template>
            <!-- 退货退款 -->
            <template v-if="row.type === 2 || row.type === 3">
              <template v-if="(buildMode !== 'SH_WEB' ? [1,5,8,9] : [1,5,9]).includes(row.status)">
                <el-dropdown>
                  <el-button type="warning">
                    {{ row.type | typeFormat }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <template v-if="row.status === 1">
                      <el-dropdown-item
                        @click.native="agreeorderreturn(row, 1)">同意</el-dropdown-item>
                      <el-dropdown-item
                        @click.native="agreeorderreturn(row, 0)">拒绝</el-dropdown-item>
                    </template>
                    <template v-if="row.status === 5">
                      <el-dropdown-item
                        @click.native="deleteRow(row)">关闭</el-dropdown-item>
                    </template>
                    <template v-if="(buildMode !== 'SH_WEB' ? [8,9] : [9]).includes(row.status) && row.type === 2">
                      <el-dropdown-item
                        @click.native="deal(row)">退款</el-dropdown-item>
                      <el-dropdown-item
                        @click.native="deal0(row, 0)">拒绝退款</el-dropdown-item>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <el-dialog
      :title="form.type | typeFormat"
      :visible.sync="visible"
      width="400px">
      <el-form
        ref="form"
        label-width="120px"
        :model="form">
        <el-form-item label="订单编号：">{{ form.orderNumber }}</el-form-item>
        <el-form-item
          key="1"
          label="退款金额：">
          <el-input-number
            v-model="form.refundAmount"
            :precision="2"
            :min="0"
            :max="form.max"></el-input-number>
        </el-form-item>
        <!-- <el-form-item label="结果描述：">
          <el-input
            v-model="form.resultDesc"
            placeholder="请输入内容"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          @click="dealSubmit(1)">退款</el-button>
        <!-- <el-button @click="dealSubmit(0)">拒绝</el-button> -->
      </div>
    </el-dialog>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
// import OrderGoodsReturnInfo from './busi/order-goods-return-info.vue'
export default {
  name: 'WxappAftersaleList',
  components: { },
  filters: {
    typeFormat(val) {
      const type = {
        1: '退款',
        2: '退货',
        3: '换货'
      }
      return type[val]
    }
  },
  data() {
    return {
      buildMode: process.env.VUE_APP_BUILD_MODE,
      loading: false,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        type: null,
        refundNumber: ''
      },
      form: {
        max: 0.01,
        type: null,
        vendorId: null,
        orderNumber: null,
        orderId: null,
        resultDesc: '',
        refundAmount: 0
      },
      visible: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('order/getorderreturns', {
        payload: {
          ...this.config,
          vendorId: this.userInfo.vendorId
        },
        success: res => {
          this.loading = false
          this.list = res.data.records.map(i => {
            i.images = i.images ? i.images.split(',') : []
            return i
          })
          this.total = res.data.total
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deal(row) {
      // this.form = {
      //   ...this.form,
      //   type: row.type,
      //   vendorId: row.vendorId,
      //   orderNumber: row.orderNumber,
      //   orderId: row.orderId,
      //   resultDesc: ''
      // }
      this.form.type = row.type
      this.form.vendorId = row.vendorId
      this.form.orderNumber = row.orderNumber
      this.form.orderId = row.orderId
      this.form.resultDesc = ''
      if (row.type === 1 || row.type === 2) {
        this.form.refundAmount = row.orderInfo.payAmount
      } else {
        this.form.refundAmount = 0
      }
      this.form.max = this.form.refundAmount
      this.visible = true
    },
    agreeorderreturn(row, result) {
      if (result === 1) {
        const title = row.type === 2 ? `退货,退款金额¥${row.orderInfo.payAmount}` : '换货'
        this.$confirm(`您将同意${title},是否确定?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.loading = true
            this.$store.dispatch('order/agreeorderreturn', {
              payload: {
                vendorId: row.vendorId,
                orderId: row.orderId,
                refundAmount: row.orderInfo.payAmount,
                result
              },
              success: () => {
                this.loading = false
                this.fetchList()
              },
              fail: () => {
                this.loading = false
              }
            })
          })
      } else {
        this.$prompt('请输入拒绝原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /.+/,
          inputErrorMessage: '拒绝原因不能为空'
        }).then(({ value }) => {
          this.loading = true
          this.$store.dispatch('order/agreeorderreturn', {
            payload: {
              vendorId: row.vendorId,
              orderId: row.orderId,
              result,
              resultDesc: value
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
      }
    },
    deal0(row, result) {
      this.$prompt('请输入拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: '拒绝原因不能为空'
      }).then(({ value }) => {
        this.loading = true
        this.$store.dispatch('order/ackorderreturn', {
          payload: {
            vendorId: row.vendorId,
            orderId: row.orderId,
            result,
            refundAmount: 0,
            resultDesc: value
          },
          success: () => {
            this.loading = false
            this.visible = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    dealSubmit(result) {
      // const title = ({
      //   1: '退款',
      //   2: '退货',
      //   3: '换货'
      // })[this.form.type]
      this.$confirm(`您将同意退款,是否确定?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('order/ackorderreturn', {
            payload: {
              vendorId: this.form.vendorId,
              orderId: this.form.orderId,
              result,
              refundAmount: this.form.refundAmount,
              resultDesc: this.form.resultDesc
            },
            success: () => {
              this.loading = false
              this.visible = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    }
  }
}
</script>
